module.exports = __webpack_public_path__ + "a6da2c3fb5f4969e29812a5929ef4d42.svg";